import { Link } from "react-router-dom";

export default function PublicFooter() {
  return (
    <footer className="border-t border-neutral-200 bg-white" data-testid="public-footer">
      <div className="max-w-6xl mx-auto px-6 py-4 flex flex-wrap items-center justify-between gap-3 text-xs text-neutral-500">
        <div>© {new Date().getFullYear()} AgencyCash</div>
        <nav className="flex flex-wrap gap-4">
          <Link to="/impressum" className="hover:text-neutral-900" data-testid="footer-impressum">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-neutral-900" data-testid="footer-datenschutz">Datenschutz</Link>
          <Link to="/agb" className="hover:text-neutral-900" data-testid="footer-agb">AGB</Link>
          <a href="mailto:hello@agency-cash.app" className="hover:text-neutral-900">Kontakt</a>
        </nav>
      </div>
    </footer>
  );
}
